/**
 * Hierarchical query-key factory for the TPAP VSC/GAP form-number list (OR-25579). Never write a literal key
 * array outside this module — the factory IS the schema.
 *
 * `GET .../ancillary-product-options/forms` is scoped by deal, product and vendor, so a vendor change lands on
 * its own cache entry rather than overwriting the previous vendor's list.
 */
export const ancillaryFormsKeys = {
  all: ["ancillaryForms"] as const,
  list: (approvalId: string | undefined, productType: string, vendorId: number | undefined) =>
    [...ancillaryFormsKeys.all, { approvalId, productType, vendorId }] as const,
};
